<template>
  <path
    d="M4.624 1.593a1 1 0 0 1 1.752 0l3.809 6.925A1 1 0 0 1 9.309 10H1.691a1 1 0 0 1-.876-1.482z"
  />
</template>

<script>
export default {
  name: 'icon-up',
};
</script>
